<template>
	<v-container>
		<v-row
			v-if="selectedItems.length > 0"
			class="d-flex align-center rounded-lg"
			:style="{ background: elementBackgroundColor }"
		>
			<v-col cols="6" class="start">
				<span :style="{ color: elementTextColor }" class="element">
					{{ selectedItems.length }} item(s) selected
				</span>
			</v-col>
			<v-col cols="6" class="end delete">
				<v-btn
					@click="deleteSelection(selectedItems)"
					prepend-icon="mdi-delete"
					variant="outlined"
					:style="{ color: elementTextColor }"
					class="delete"
					>DELETE</v-btn
				>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col>
				<v-data-table
					:headers="headers"
					:items="list"
					:sort-by="[{ key: 'name', order: 'asc' }]"
					:items-per-page="15"
					:items-per-page-options="[
						{ value: 15, title: '15' },
						{ value: 30, title: '30' },
						{ value: 50, title: '50' },
						{ value: 100, title: '100' },
						{ value: 200, title: '200' },
					]"
					:search="search"
					loading-text="Loading... Please wait"
					:multi-sort="true"
					:hover="true"
					:show-select="shouldShowSelect"
					v-model="selectedItems"
				>
					<template v-slot:top>
						<div class="d-flex align-center">
							<span class="font-weight-medium">Terminal</span>
							<v-spacer></v-spacer>
							<v-text-field
								class="row align-right"
								v-model="search"
								append-icon="mdi-magnify"
								label="Search"
								single-line
								hide-details
							></v-text-field>
							<v-spacer></v-spacer>
							<v-dialog v-model="dialog" max-width="75%">
								<template v-slot:activator="{ props }">
									<v-btn variant="outlined" v-bind="props">New Terminal</v-btn>
								</template>
								<v-card>
									<v-card-title>
										<span class="font-weight-bold">{{ itemTitle }}</span>
									</v-card-title>
									<v-card-text>
										<v-container>
											<input type="hidden" v-model="editItem.id" />
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.name"
												label="Name"
											></v-text-field>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.code"
												label="Terminal ID"
											></v-text-field>
											<v-autocomplete
												v-model="editItem.pinKeyId"
												:items="keylist"
												item-title="name"
												item-value="id"
												label="Pin Key"
												placeholder="Pin Key"
												class="w-auto"
												variant="outlined"
											>
												<template v-slot:append>
													<v-btn
														style="margin-left: -5%"
														icon
														variant="outlined"
														@click="clearProperty('pinKeyId')"
														v-show="editItem.pinKeyId !== null"
														size="small"
													>
														<v-icon style="font-size: 250%">mdi-close</v-icon>
													</v-btn>
												</template></v-autocomplete
											>
											<v-autocomplete
												v-model="editItem.macKeyId"
												:items="keylist"
												item-title="name"
												item-value="id"
												label="Mac Key"
												placeholder="Mac Key"
												class="w-auto"
												variant="outlined"
												><template v-slot:append>
													<v-btn
														style="margin-left: -5%"
														icon
														variant="outlined"
														@click="clearProperty('macKeyId')"
														v-show="editItem.macKeyId !== null"
														size="small"
													>
														<v-icon style="font-size: 250%">mdi-close</v-icon>
													</v-btn>
												</template></v-autocomplete
											>
											<v-autocomplete
												v-model="editItem.dataKeyId"
												:items="keylist"
												item-title="name"
												item-value="id"
												label="Data Key"
												placeholder="Data Key"
												class="w-auto"
												variant="outlined"
												><template v-slot:append>
													<v-btn
														style="margin-left: -5%"
														icon
														variant="outlined"
														@click="clearProperty('dataKeyId')"
														v-show="editItem.dataKeyId !== null"
														size="small"
													>
														<v-icon style="font-size: 250%">mdi-close</v-icon>
													</v-btn>
												</template></v-autocomplete
											>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.pinSessionKey"
												label="Pin Session Key"
											></v-text-field>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.macSessionKey"
												label="Mac Session Key"
											></v-text-field>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.dataSessionKey"
												label="Data Session Key"
											></v-text-field>
											<v-switch
												class="w-auto"
												variant="outlined"
												v-model="editItem.forceSendResponseCode"
												label="Force Response Code"
											></v-switch>
											<v-autocomplete
												v-model="editItem.responsCodeId"
												:items="responsecodelist"
												item-title="name"
												item-value="id"
												label="Respons Code"
												placeholder="Response Code"
												class="w-auto"
												variant="outlined"
												closable-chips
											>
												<template v-slot:append>
													<v-btn
														style="margin-left: -5%"
														icon
														variant="outlined"
														@click="clearProperty('responsCodeId')"
														v-show="editItem.responsCodeId !== null"
														size="small"
													>
														<v-icon style="font-size: 250%">mdi-close</v-icon>
													</v-btn>
												</template>
											</v-autocomplete>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.shiftNumber"
												label="Shift Number"
											></v-text-field>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.batchNumber"
												label="Batc Number"
											></v-text-field>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.sequenceNumber"
												label="Sequence Number"
											>
											</v-text-field>
										</v-container>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn variant="text" @click="close">Cancel</v-btn>
										<v-btn
											color="primary"
											variant="text"
											@click="funSaveItem"
											:loading="loading"
											>Save</v-btn
										>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</div>
					</template>

					<template v-slot:[`item.forceSendResponseCode`]="{ item }">
						<v-switch
							class="ma-0 pa-0 form-label"
							dense
							v-model="item.forceSendResponseCode"
							@change="switchForceRC(item)"
						></v-switch>

						<div
							v-if="item.forceSendResponseCode"
							style="margin-top: -13%"
						>
							Response Code:
						</div>
						<div
							v-if="item.forceSendResponseCode"
							style="font-weight: bold"
						>
							{{ getResponseCodeName(item.responsCodeId) }}
						</div>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-icon @click="funEditItem(item)">mdi-pencil</v-icon>
						<v-icon @click="funDeleteItem(item)">mdi-delete</v-icon>
					</template>
					<template v-slot:no-data>
						<span>No Data Available</span>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
	CREATE_TERMINAL,
	EDIT_TERMINAL,
	REMOVE_TERMINAL,
	REMOVE_TERMINALS,
} from "@/store/_actiontypes";

export default {
	data: () => ({
		loading: false,
		search: "",
		dialog: false,
		menu: false,
		selectedItems: [],
		headers: [
			{ title: "Id", key: "id", align: " d-none" },
			{ title: "Name", key: "name" },
			{ title: "Terminal ID", key: "code" },
			{ title: "Pin Key", key: "pinKeyName" },
			{ title: "Mac Key", key: "macKeyName" },
			{ title: "Data Key", key: "dataKeyName" },
			{ title: "Shift", key: "shiftNumber" },
			{ title: "Batch", key: "batchNumber" },
			{ title: "Sequence", key: "sequenceNumber" },
			{ title: "Force RC", key: "forceSendResponseCode" },
			{ title: "Actions", key: "action", sortable: false, width: 50 },
		],
		editItem: {
			id: 0,
			name: "",
			code: "",
			pinKeyId: "TEST EGCP",
			pinKeyName: "",
			macKeyId: "TEST EGCP",
			macKeyName: "",
			dataKeyId: "TEST EGCP",
			dataKeyName: "",
			pinSessionKey: "",
			macSessionKey: "",
			dataSessionKey: "",
			shiftNumber: 0,
			batchNumber: 0,
			sequenceNumber: 1,
			lastRC: "",
			forceSendResponseCode: false,
			responsCodeId: "KRIVI PIN",
		},
		defaultItem: {
			id: 0,
			name: "",
			code: "",
			pinKeyId: "1",
			pinKeyName: "",
			macKeyId: "1",
			macKeyName: "",
			dataKeyId: "1",
			dataKeyName: "",
			pinSessionKey: "",
			macSessionKey: "",
			dataSessionKey: "",
			shiftNumber: 0,
			batchNumber: 0,
			sequenceNumber: 1,
			lastRC: "",
			forceSendResponseCode: false,
			responsCodeId: "1",
		},
	}),
	computed: {
		...mapState("keys", ["keylist"]),
		...mapState("responscodes", ["responsecodelist"]),
		...mapState({ list: (state) => state.terminals.terminallist }),
		itemTitle() {
			return this.editItem.id === 0 ? "New Terminal" : "Edit Terminal";
		},
		shouldShowSelect() {
			return this.list.length >= 1;
		},

		elementTextColor() {
			return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
		},
		elementBackgroundColor() {
			return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
		},
	},
	watch: {
		dialog(val) {
			val || this.close();
		},
		selectedItems(val) {
			this.selectedItems = val;
		},
	},
	methods: {
		...mapActions("terminals", [
			CREATE_TERMINAL,
			EDIT_TERMINAL,
			REMOVE_TERMINAL,
			REMOVE_TERMINALS,
		]),
		clearProperty(propertyName) {
			this.editItem[propertyName] = null;
		},
		funEditItem(item) {
			this.editItem = Object.assign({}, item);
			this.dialog = true;
		},
		switchForceRC(item) {
			this.editItem = Object.assign({}, item);
			this.funSaveItem();
		},
		funDeleteItem(item) {
			confirm("Are you sure you want to delete this item?") &&
				this.REMOVE_TERMINAL({ id: item.id });
		},
		deleteSelection() {
			const ids = [];
			for (var val in this.selectedItems) {
				ids.push(this.selectedItems[val]);
			}
			if (
				confirm(
					`Are you sure you want to delete ${ids.length} selected item(s)?`
				)
			) {
				this.REMOVE_TERMINALS({ ids: ids });
				this.selectedItems = [];
			}
		},

		close() {
			this.dialog = false;
		},
		funSaveItem() {
			this.loading = true;
			var item = this.editItem;
			if (item.id == 0) {
				if (!Number.isInteger(item.pinKeyId)) {
					item.pinKeyId = this.defaultItem.pinKeyId;
				}
				if (!Number.isInteger(item.macKeyId)) {
					item.macKeyId = this.defaultItem.macKeyId;
				}
				if (!Number.isInteger(item.dataKeyId)) {
					item.dataKeyId = this.defaultItem.dataKeyId;
				}
				if (!Number.isInteger(item.responsCodeId)) {
					item.responsCodeId = this.defaultItem.responsCodeId;
				}
				this.CREATE_TERMINAL({
					item,
				})
					.then(() => {
						this.close();
					})
					.finally(() => {
						this.loading = false;
						console.log(item.forceSendResponseCode);
					});
			} else {
				this.EDIT_TERMINAL({
					item,
				})
					.then(() => {
						this.close();
					})
					.finally(() => {
						this.loading = false;
						console.log(item.forceSendResponseCode);
					});
			}
		},
		getResponseCodeName(id) {
			const responseCode = this.responsecodelist.find((code) => code.id === id);
			return responseCode ? responseCode.name : "";
		},
	},
};
</script>

<style>
.myclass {
	display: flex;
	justify-content: space-between;
}

.element {
	padding: 10px;
	border: none;
	color: black;
}

.start {
	display: flex;
	justify-content: flex-start;
}

.end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.delete {
	cursor: pointer;
}
</style>
